import React, { useMemo } from 'react';
import { View } from '../../../../../../components/Common/react-native-components';
import GenericNoData from '../../../../../../components/Common/NoData/GenricNoData';
import TopicPlot from '../../../../../../components/Common/TopicPlot';

const ReviewTopicPlot = props => {
  const { itemData, type, onTopicClick, widgetData } = props;

  const noData = useMemo(() => {
    return !(itemData?.top_topics?.length || itemData?.bottom_topics?.length);
  }, [itemData]);

  const colorRules = {
    ranges: [
      {
        min: 1,
        max: 999,
        color: '#8ACA90'
      },
      {
        min: 0,
        max: 1,
        color: '#E8F7EB'
      },
      {
        min: -1,
        max: 0,
        color: '#F5D6D6'
      },
      {
        min: -999,
        max: -1,
        color: '#E16067'
      }
    ]
  };

  function renderContent() {
    switch (type) {
      case 'TABLE':
        return (
          <TopicPlot
            onTopicClick={onTopicClick}
            colorRules={widgetData?.colorRules || colorRules}
            topicData={itemData || {}}
          />
        );
      case 'BAR':
        return (
          <TopicPlot
            onTopicClick={onTopicClick}
            colorRules={widgetData?.colorRules || colorRules}
            topicData={itemData || {}}
            isChartView={true}
          />
        );
      default:
        return null;
    }
  }
  if (noData) {
    return <GenericNoData />;
  }

  return <View>{renderContent()}</View>;
};

export default ReviewTopicPlot;
